var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "36", height: "35", viewBox: "0 0 36 35", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M0 3.889V31.11C0 33.25 1.78 35 4 35h28c2.2 0 4-1.75 4-3.889V3.89C36 1.75 34.2 0 32 0H4C1.78 0 0 1.75 0 3.889zm24 7.778c0 3.227-2.68 5.833-6 5.833s-6-2.606-6-5.833c0-3.228 2.68-5.834 6-5.834s6 2.606 6 5.834zM6 27.222c0-3.889 8-6.028 12-6.028s12 2.14 12 6.028v1.945H6v-1.945z", fill: "#CE90EB" })
  );
});